import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";
import useReturnReasonsAnalytics from "@babackapp/private-api-client/client/use-return-reasons-analytics";
import useTranslation from "@babackapp/translations/use-translation";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@babackapp/ui/components/card";
import { ScrollArea } from "@babackapp/ui/components/scroll-area";
import { useDashboardFilters } from "../lib/dashboard-filters";
import useFormattedTimeRange from "../lib/use-formatted-time-range";
import { ReturnReasonListItem } from "./return-reason-list-item";
import { useMemo } from "react";

type ReturnRequestReasonsListProps = {
  setReasonFilter: (
      reason: string | undefined,
  ) => void;
};

export function ReturnRequestReasonsList(
    { setReasonFilter }: ReturnRequestReasonsListProps,
) {
  const { data: shop } = useCurrentShopSuspense();
  const { toTimestamp, fromTimestamp, productId, variantId, resolution, reason } =
    useDashboardFilters();

  const { data: stats } = useReturnReasonsAnalytics({
    shopId: shop.id,
    fromTimestamp: fromTimestamp,
    toTimestamp: toTimestamp ?? 0,
    productId,
    variantId,
    resolution,
    reason
  });

  const total = useMemo((): number => {
    return (stats ?? []).reduce((acc, stat): number => {
      return acc + stat.count;
    }, 0);
  }, [stats]);

  const timeRange = useFormattedTimeRange();

  const t = useTranslation();

  return (
    <Card className="col-span-2">
      <CardHeader className="pb-0">
        <CardTitle className="text-md">
          {t("analyticsDashboard.returnReasons.title")}
        </CardTitle>
        <CardDescription>{timeRange}</CardDescription>
      </CardHeader>
      <CardContent>
        <ScrollArea className="h-96 mt-4">
          <div className="flex flex-col gap-2">
            {(stats ?? []).map((stat) => (
              <div key={stat.id} onClick={() => setReasonFilter(stat.id)} className="cursor-pointer">
                <ReturnReasonListItem
                  values={stat.values}
                  count={stat.count}
                  total={total}
                />
              </div>
            ))}
          </div>
        </ScrollArea>
      </CardContent>
    </Card>
  );
}
